
class Logout {

    constructor(el = {}) {
        this.logout = this.logout.bind(this);
        const logoutBtn = document.querySelector('.button__Logout');
        if (logoutBtn) {
            logoutBtn.addEventListener('click', this.logout);
        }
    }

    getBranchName() {
        const branchBtn = document.querySelector('.branch__open');
        if (!branchBtn) return
        let branchName = branchBtn.innerText
        return branchName.toUpperCase().includes('BRANSCH') ? "no_branch" : branchName.charAt(0).toUpperCase() + branchName.slice(1).toLowerCase()
    }

    logout(e) {
        e.preventDefault();
        dataLayer.push({
            'event': 'login',
            'logedinStatus': 'Logout',   // Login|Logout
            'selectedBranch': this.getBranchName()
        });

        fetch('/auth/logout', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }).then((response) => {
            if (response.status >= 200 && response.status < 300) {
                return response;
            } else {
                var error = new Error(response.statusText);
                error.response = response;
                throw error;
            }
        }).then((response) => {
            return response.json();
        }).then((json) => {
            window.location = json.redirectUrl;
            //window.location = window.location;
        }).catch((ex) => {
            console.info(ex);
        });
    }
}

document.addEventListener("DOMContentLoaded", () => { new Logout(); });